import React from 'react';
import BreadcrumbDesigning from '../BreadcrumbDesigning';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataAppDesigning } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import { Link } from 'react-router-dom';

const AppDesigning = () => {
  return (
    <div className="page-container-app-designing">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
            <h1 className='heading'>App Designing</h1>
          </div>
            <Link to="/app-designing" className='no-decoration'><BreadcrumbDesigning text={"App Designing"} /></Link>  
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataAppDesigning} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default AppDesigning